import { render, staticRenderFns } from "./UpdateRole.vue?vue&type=template&id=2c5c6d0a&scoped=true"
import script from "./UpdateRole.vue?vue&type=script&lang=js"
export * from "./UpdateRole.vue?vue&type=script&lang=js"
import style1 from "./UpdateRole.vue?vue&type=style&index=1&id=2c5c6d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c6d0a",
  null
  
)

export default component.exports